var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: [_vm.likeLoading ? 'is-flashing' : '', 'cm-button', 'is-inverted'],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleLike($event)
      }
    }
  }, [(_vm.liked) ? [_vm._v("\n    Unlike\n  ")] : [_vm._v("\n    Like\n  ")]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cd953a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/like.vue
// module id = null
// module chunks = 